<!-- Sidebar Menu -->
<div class="kt-menu flex flex-col gap-2.5 grow" data-kt-menu="true" id="sidebar_menu">
	<div class="kt-menu-item active">
		<a class="kt-menu-link rounded-[9px] border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border w-[62px] h-[60px] flex flex-col justify-center items-center gap-1 p-2"
			href="/metronic/tailwind/demo8/">
			<span
				class="kt-menu-icon kt-menu-item-here:text-primary kt-menu-item-active:text-primary kt-menu-link-hover:text-primary text-secondary-foreground">
				<i class="ki-filled ki-chart-line-star text-xl">
				</i>
			</span>
			<span
				class="kt-menu-title text-xs kt-menu-item-here:text-primary kt-menu-item-active:text-primary kt-menu-link-hover:text-primary text-secondary-foreground font-medium">
				Boards
			</span>
		</a>
	</div>
	<div class="kt-menu-item kt-menu-item-dropdown" data-kt-menu-item-offset="-10px, 14px"
		data-kt-menu-item-overflow="true" data-kt-menu-item-placement="right-start" data-kt-menu-item-toggle="dropdown"
		data-kt-menu-item-trigger="click|lg:hover">
		<div
			class="kt-menu-link rounded-[9px] border border-transparent kt-menu-item-here:border-border kt-menu-item-here:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border w-[62px] h-[60px] flex flex-col justify-center items-center gap-1 p-2 grow">
			<span
				class="kt-menu-icon kt-menu-item-here:text-primary kt-menu-item-active:text-primary kt-menu-link-hover:text-primary text-secondary-foreground">
				<i class="ki-filled ki-profile-circle text-xl">
				</i>
			</span>
			<span
				class="kt-menu-title kt-menu-item-here:text-primary kt-menu-item-active:text-primary kt-menu-link-hover:text-primary font-medium text-xs text-secondary-foreground">
				Profiles
			</span>
		</div>
		<div
			class="kt-menu-default kt-menu-dropdown gap-0.5 w-[220px] kt-scrollable-y-auto lg:overflow-visible max-h-[50vh]">
			<div class="kt-menu-item kt-menu-item-dropdown" data-kt-menu-item-placement="right-start"
				data-kt-menu-item-toggle="accordion|lg:dropdown" data-kt-menu-item-trigger="click|lg:hover">
				<div class="kt-menu-link grow cursor-pointer">
					<span class="kt-menu-title">
						Profiles
					</span>
					<span class="kt-menu-arrow">
						<i class="ki-filled ki-right text-xs rtl:translate rtl:rotate-180">
						</i>
					</span>
				</div>
				<div class="kt-menu-default kt-menu-dropdown gap-0.5 w-[220px]">
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/public-profile/profiles/default">
							<span class="kt-menu-title">
								Default
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/public-profile/profiles/creator">
							<span class="kt-menu-title">
								Creator
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/public-profile/profiles/company">
							<span class="kt-menu-title">
								Company
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/public-profile/profiles/nft">
							<span class="kt-menu-title">
								NFT
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/public-profile/profiles/blogger">
							<span class="kt-menu-title">
								Blogger
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/public-profile/profiles/crm">
							<span class="kt-menu-title">
								CRM
							</span>
						</a>
					</div>
					<div class="kt-menu-item kt-menu-item-dropdown" data-kt-menu-item-placement="right-start"
						data-kt-menu-item-toggle="accordion|lg:dropdown" data-kt-menu-item-trigger="click|lg:hover">
						<div class="kt-menu-link grow cursor-pointer">
							<span class="kt-menu-title">
								More
							</span>
							<span class="kt-menu-arrow">
								<i class="ki-filled ki-right text-xs rtl:translate rtl:rotate-180">
								</i>
							</span>
						</div>
						<div class="kt-menu-default kt-menu-dropdown gap-0.5 w-[220px]">
							<div class="kt-menu-item">
								<a class="kt-menu-link" href="/metronic/tailwind/demo8/public-profile/profiles/gamer">
									<span class="kt-menu-title">
										Gamer
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link" href="/metronic/tailwind/demo8/public-profile/profiles/feeds">
									<span class="kt-menu-title">
										Feeds
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link" href="/metronic/tailwind/demo8/public-profile/profiles/plain">
									<span class="kt-menu-title">
										Plain
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link" href="/metronic/tailwind/demo8/public-profile/profiles/modal">
									<span class="kt-menu-title">
										Modal
									</span>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="kt-menu-item kt-menu-item-dropdown" data-kt-menu-item-placement="right-start"
				data-kt-menu-item-toggle="accordion|lg:dropdown" data-kt-menu-item-trigger="click|lg:hover">
				<div class="kt-menu-link grow cursor-pointer">
					<span class="kt-menu-title">
						Projects
					</span>
					<span class="kt-menu-arrow">
						<i class="ki-filled ki-right text-xs rtl:translate rtl:rotate-180">
						</i>
					</span>
				</div>
				<div class="kt-menu-default kt-menu-dropdown gap-0.5 w-[220px]">
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/public-profile/projects/3-columns">
							<span class="kt-menu-title">
								3 Columns
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/public-profile/projects/2-columns">
							<span class="kt-menu-title">
								2 Columns
							</span>
						</a>
					</div>
				</div>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="/metronic/tailwind/demo8/public-profile/works">
					<span class="kt-menu-title">
						Works
					</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="/metronic/tailwind/demo8/public-profile/teams">
					<span class="kt-menu-title">
						Teams
					</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="/metronic/tailwind/demo8/public-profile/network">
					<span class="kt-menu-title">
						Network
					</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="/metronic/tailwind/demo8/public-profile/activity">
					<span class="kt-menu-title">
						Activity
					</span>
				</a>
			</div>
			<div class="kt-menu-item kt-menu-item-dropdown" data-kt-menu-item-placement="right-start"
				data-kt-menu-item-toggle="accordion|lg:dropdown" data-kt-menu-item-trigger="click|lg:hover">
				<div class="kt-menu-link grow cursor-pointer">
					<span class="kt-menu-title">
						More
					</span>
					<span class="kt-menu-arrow">
						<i class="ki-filled ki-right text-xs rtl:translate rtl:rotate-180">
						</i>
					</span>
				</div>
				<div class="kt-menu-default kt-menu-dropdown gap-0.5 w-[220px]">
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/public-profile/campaigns/card">
							<span class="kt-menu-title">
								Campaigns - Card
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/public-profile/campaigns/list">
							<span class="kt-menu-title">
								Campaigns - List
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/public-profile/empty">
							<span class="kt-menu-title">
								Empty
							</span>
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="kt-menu-item kt-menu-item-dropdown" data-kt-menu-item-offset="-10px, 14px"
		data-kt-menu-item-overflow="true" data-kt-menu-item-placement="right-start" data-kt-menu-item-toggle="dropdown"
		data-kt-menu-item-trigger="click|lg:hover">
		<div
			class="kt-menu-link rounded-[9px] border border-transparent kt-menu-item-here:border-border kt-menu-item-here:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border w-[62px] h-[60px] flex flex-col justify-center items-center gap-1 p-2 grow">
			<span
				class="kt-menu-icon kt-menu-item-here:text-primary kt-menu-item-active:text-primary kt-menu-link-hover:text-primary text-secondary-foreground">
				<i class="ki-filled ki-setting-2 text-xl">
				</i>
			</span>
			<span
				class="kt-menu-title kt-menu-item-here:text-primary kt-menu-item-active:text-primary kt-menu-link-hover:text-primary font-medium text-xs text-secondary-foreground">
				Account
			</span>
		</div>
		<div
			class="kt-menu-default kt-menu-dropdown gap-0.5 w-[220px] kt-scrollable-y-auto lg:overflow-visible max-h-[50vh]">
			<div class="kt-menu-item kt-menu-item-dropdown" data-kt-menu-item-placement="right-start"
				data-kt-menu-item-toggle="accordion|lg:dropdown" data-kt-menu-item-trigger="click|lg:hover">
				<div class="kt-menu-link grow cursor-pointer">
					<span class="kt-menu-title">
						Account Home
					</span>
					<span class="kt-menu-arrow">
						<i class="ki-filled ki-right text-xs rtl:translate rtl:rotate-180">
						</i>
					</span>
				</div>
				<div class="kt-menu-default kt-menu-dropdown gap-0.5 w-[220px]">
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/home/get-started">
							<span class="kt-menu-title">
								Get Started
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/home/user-profile">
							<span class="kt-menu-title">
								User Profile
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/home/company-profile">
							<span class="kt-menu-title">
								Company Profile
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/home/settings-sidebar">
							<span class="kt-menu-title">
								Settings - With Sidebar
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/home/settings-enterprise">
							<span class="kt-menu-title">
								Settings - Enterprise
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/home/settings-plain">
							<span class="kt-menu-title">
								Settings - Plain
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/home/settings-modal">
							<span class="kt-menu-title">
								Settings - Modal
							</span>
						</a>
					</div>
				</div>
			</div>
			<div class="kt-menu-item kt-menu-item-dropdown" data-kt-menu-item-placement="right-start"
				data-kt-menu-item-toggle="accordion|lg:dropdown" data-kt-menu-item-trigger="click|lg:hover">
				<div class="kt-menu-link grow cursor-pointer">
					<span class="kt-menu-title">
						Billing
					</span>
					<span class="kt-menu-arrow">
						<i class="ki-filled ki-right text-xs rtl:translate rtl:rotate-180">
						</i>
					</span>
				</div>
				<div class="kt-menu-default kt-menu-dropdown gap-0.5 w-[220px]">
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/billing/basic">
							<span class="kt-menu-title">
								Billing - Basic
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/billing/enterprise">
							<span class="kt-menu-title">
								Billing - Enterprise
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/billing/plans">
							<span class="kt-menu-title">
								Plans
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/billing/history">
							<span class="kt-menu-title">
								Billing History
							</span>
						</a>
					</div>
				</div>
			</div>
			<div class="kt-menu-item kt-menu-item-dropdown" data-kt-menu-item-placement="right-start"
				data-kt-menu-item-toggle="accordion|lg:dropdown" data-kt-menu-item-trigger="click|lg:hover">
				<div class="kt-menu-link grow cursor-pointer">
					<span class="kt-menu-title">
						Security
					</span>
					<span class="kt-menu-arrow">
						<i class="ki-filled ki-right text-xs rtl:translate rtl:rotate-180">
						</i>
					</span>
				</div>
				<div class="kt-menu-default kt-menu-dropdown gap-0.5 w-[220px]">
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/security/get-started">
							<span class="kt-menu-title">
								Get Started
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/security/overview">
							<span class="kt-menu-title">
								Security Overview
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/security/allowed-ip-addresses">
							<span class="kt-menu-title">
								Allowed IP Addresses
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/security/privacy-settings">
							<span class="kt-menu-title">
								Privacy Settings
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/security/device-management">
							<span class="kt-menu-title">
								Device Management
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/security/backup-and-recovery">
							<span class="kt-menu-title">
								Backup &amp; Recovery
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/security/current-sessions">
							<span class="kt-menu-title">
								Current Sessions
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/security/security-log">
							<span class="kt-menu-title">
								Security Log
							</span>
						</a>
					</div>
				</div>
			</div>
			<div class="kt-menu-item kt-menu-item-dropdown" data-kt-menu-item-placement="right-start"
				data-kt-menu-item-toggle="accordion|lg:dropdown" data-kt-menu-item-trigger="click|lg:hover">
				<div class="kt-menu-link grow cursor-pointer">
					<span class="kt-menu-title">
						Members &amp; Roles
					</span>
					<span class="kt-menu-arrow">
						<i class="ki-filled ki-right text-xs rtl:translate rtl:rotate-180">
						</i>
					</span>
				</div>
				<div class="kt-menu-default kt-menu-dropdown gap-0.5 w-[220px]">
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/members/team-starter">
							<span class="kt-menu-title">
								Teams Starter
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/members/teams">
							<span class="kt-menu-title">
								Teams
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/members/team-info">
							<span class="kt-menu-title">
								Team Info
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/members/members-starter">
							<span class="kt-menu-title">
								Members Starter
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/members/team-members">
							<span class="kt-menu-title">
								Team Members
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/members/import-members">
							<span class="kt-menu-title">
								Import Members
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/members/roles">
							<span class="kt-menu-title">
								Roles
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/members/permissions-toggle">
							<span class="kt-menu-title">
								Permissions - Toggler
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/members/permissions-check">
							<span class="kt-menu-title">
								Permissions - Check
							</span>
						</a>
					</div>
				</div>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/integrations">
					<span class="kt-menu-title">
						Integrations
					</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/notifications">
					<span class="kt-menu-title">
						Notifications
					</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/api-keys">
					<span class="kt-menu-title">
						API Keys
					</span>
				</a>
			</div>
			<div class="kt-menu-item kt-menu-item-dropdown" data-kt-menu-item-placement="right-start"
				data-kt-menu-item-toggle="accordion|lg:dropdown" data-kt-menu-item-trigger="click|lg:hover">
				<div class="kt-menu-link grow cursor-pointer">
					<span class="kt-menu-title">
						More
					</span>
					<span class="kt-menu-arrow">
						<i class="ki-filled ki-right text-xs rtl:translate rtl:rotate-180">
						</i>
					</span>
				</div>
				<div class="kt-menu-default kt-menu-dropdown gap-0.5 w-[220px]">
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/appearance">
							<span class="kt-menu-title">
								Appearance
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/invite-a-friend">
							<span class="kt-menu-title">
								Invite a Friend
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/account/activity">
							<span class="kt-menu-title">
								Activity
							</span>
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="kt-menu-item kt-menu-item-dropdown" data-kt-menu-item-offset="-10px, 14px"
		data-kt-menu-item-overflow="true" data-kt-menu-item-placement="right-start" data-kt-menu-item-toggle="dropdown"
		data-kt-menu-item-trigger="click|lg:hover">
		<div
			class="kt-menu-link rounded-[9px] border border-transparent kt-menu-item-here:border-border kt-menu-item-here:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border w-[62px] h-[60px] flex flex-col justify-center items-center gap-1 p-2 grow">
			<span
				class="kt-menu-icon kt-menu-item-here:text-primary kt-menu-item-active:text-primary kt-menu-link-hover:text-primary text-secondary-foreground">
				<i class="ki-filled ki-users text-xl">
				</i>
			</span>
			<span
				class="kt-menu-title kt-menu-item-here:text-primary kt-menu-item-active:text-primary kt-menu-link-hover:text-primary font-medium text-xs text-secondary-foreground">
				Network
			</span>
		</div>
		<div
			class="kt-menu-default kt-menu-dropdown gap-0.5 w-[220px] kt-scrollable-y-auto lg:overflow-visible max-h-[50vh]">
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="/metronic/tailwind/demo8/network/get-started">
					<span class="kt-menu-title">
						Get Started
					</span>
				</a>
			</div>
			<div class="kt-menu-item kt-menu-item-dropdown" data-kt-menu-item-placement="right-start"
				data-kt-menu-item-toggle="accordion|lg:dropdown" data-kt-menu-item-trigger="click|lg:hover">
				<div class="kt-menu-link grow cursor-pointer">
					<span class="kt-menu-title">
						User Cards
					</span>
					<span class="kt-menu-arrow">
						<i class="ki-filled ki-right text-xs rtl:translate rtl:rotate-180">
						</i>
					</span>
				</div>
				<div class="kt-menu-default kt-menu-dropdown gap-0.5 w-[220px]">
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/network/user-cards/mini-cards">
							<span class="kt-menu-title">
								Mini Cards
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/network/user-cards/team-crew">
							<span class="kt-menu-title">
								Team Crew
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/network/user-cards/author">
							<span class="kt-menu-title">
								Author
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/network/user-cards/nft">
							<span class="kt-menu-title">
								NFT
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/network/user-cards/social">
							<span class="kt-menu-title">
								Social
							</span>
						</a>
					</div>
				</div>
			</div>
			<div class="kt-menu-item kt-menu-item-dropdown" data-kt-menu-item-placement="right-start"
				data-kt-menu-item-toggle="accordion|lg:dropdown" data-kt-menu-item-trigger="click|lg:hover">
				<div class="kt-menu-link grow cursor-pointer">
					<span class="kt-menu-title">
						User Table
					</span>
					<span class="kt-menu-arrow">
						<i class="ki-filled ki-right text-xs rtl:translate rtl:rotate-180">
						</i>
					</span>
				</div>
				<div class="kt-menu-default kt-menu-dropdown gap-0.5 w-[220px]">
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/network/user-table/team-crew">
							<span class="kt-menu-title">
								Team Crew
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/network/user-table/app-roster">
							<span class="kt-menu-title">
								App Roster
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/network/user-table/market-authors">
							<span class="kt-menu-title">
								Market Authors
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/network/user-table/saas-users">
							<span class="kt-menu-title">
								SaaS Users
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/network/user-table/store-clients">
							<span class="kt-menu-title">
								Store Clients
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/network/user-table/visitors">
							<span class="kt-menu-title">
								Visitors
							</span>
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="kt-menu-item kt-menu-item-dropdown" data-kt-menu-item-offset="-10px, 14px"
		data-kt-menu-item-overflow="true" data-kt-menu-item-placement="right-start" data-kt-menu-item-toggle="dropdown"
		data-kt-menu-item-trigger="click|lg:hover">
		<div
			class="kt-menu-link rounded-[9px] border border-transparent kt-menu-item-here:border-border kt-menu-item-here:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border w-[62px] h-[60px] flex flex-col justify-center items-center gap-1 p-2 grow">
			<span
				class="kt-menu-icon kt-menu-item-here:text-primary kt-menu-item-active:text-primary kt-menu-link-hover:text-primary text-secondary-foreground">
				<i class="ki-filled ki-handcart text-xl">
				</i>
			</span>
			<span
				class="kt-menu-title kt-menu-item-here:text-primary kt-menu-item-active:text-primary kt-menu-link-hover:text-primary font-medium text-xs text-secondary-foreground">
				Store
			</span>
		</div>
		<div
			class="kt-menu-default kt-menu-dropdown gap-0.5 w-[220px] kt-scrollable-y-auto lg:overflow-visible max-h-[50vh]">
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="/metronic/tailwind/demo8/store-client/home">
					<span class="kt-menu-title">
						Home
					</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="/metronic/tailwind/demo8/store-client/search-results-grid">
					<span class="kt-menu-title">
						Search Results - Grid
					</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="/metronic/tailwind/demo8/store-client/search-results-list">
					<span class="kt-menu-title">
						Search Results - List
					</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="/metronic/tailwind/demo8/store-client/product-details">
					<span class="kt-menu-title">
						Product Details
					</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="/metronic/tailwind/demo8/store-client/shopping-cart">
					<span class="kt-menu-title">
						Shopping Cart
					</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="/metronic/tailwind/demo8/store-client/wishlist">
					<span class="kt-menu-title">
						Wishlist
					</span>
				</a>
			</div>
			<div class="kt-menu-item kt-menu-item-dropdown" data-kt-menu-item-placement="right-start"
				data-kt-menu-item-toggle="accordion|lg:dropdown" data-kt-menu-item-trigger="click|lg:hover">
				<div class="kt-menu-link grow cursor-pointer">
					<span class="kt-menu-title">
						Checkout
					</span>
					<span class="kt-menu-arrow">
						<i class="ki-filled ki-right text-xs rtl:translate rtl:rotate-180">
						</i>
					</span>
				</div>
				<div class="kt-menu-default kt-menu-dropdown gap-0.5 w-[220px]">
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/store-client/checkout/order-summary">
							<span class="kt-menu-title">
								Order Summary
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/store-client/checkout/shipping-info">
							<span class="kt-menu-title">
								Shipping Info
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/store-client/checkout/payment-method">
							<span class="kt-menu-title">
								Payment Method
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="/metronic/tailwind/demo8/store-client/checkout/order-placed">
							<span class="kt-menu-title">
								Order Placed
							</span>
						</a>
					</div>
				</div>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="/metronic/tailwind/demo8/store-client/my-orders">
					<span class="kt-menu-title">
						My Orders
					</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="/metronic/tailwind/demo8/store-client/order-receipt">
					<span class="kt-menu-title">
						Order Receipt
					</span>
				</a>
			</div>
		</div>
	</div>
	<div class="kt-menu-item kt-menu-item-dropdown" data-kt-menu-item-offset="-10px, 14px"
		data-kt-menu-item-overflow="true" data-kt-menu-item-placement="right-start" data-kt-menu-item-toggle="dropdown"
		data-kt-menu-item-trigger="click|lg:hover">
		<div
			class="kt-menu-link rounded-[9px] border border-transparent kt-menu-item-here:border-border kt-menu-item-here:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border w-[62px] h-[60px] flex flex-col justify-center items-center gap-1 p-2 grow">
			<span
				class="kt-menu-icon kt-menu-item-here:text-primary kt-menu-item-active:text-primary kt-menu-link-hover:text-primary text-secondary-foreground">
				<i class="ki-filled ki-share text-xl">
				</i>
			</span>
			<span
				class="kt-menu-title kt-menu-item-here:text-primary kt-menu-item-active:text-primary kt-menu-link-hover:text-primary font-medium text-xs text-secondary-foreground">
				Help
			</span>
		</div>
		<div
			class="kt-menu-default kt-menu-dropdown gap-0.5 w-[220px] kt-scrollable-y-auto lg:overflow-visible max-h-[50vh]">
			<div class="kt-menu-item">
				<a class="kt-menu-link"
					href="https://keenthemes.com/metronic/tailwind/docs/getting-started/installation">
					<span class="kt-menu-title">
						Getting Started
					</span>
				</a>
			</div>
			<div class="kt-menu-item kt-menu-item-dropdown" data-kt-menu-item-placement="right-start"
				data-kt-menu-item-toggle="accordion|lg:dropdown" data-kt-menu-item-trigger="click|lg:hover">
				<div class="kt-menu-link grow cursor-pointer">
					<span class="kt-menu-title">
						Support Forum
					</span>
					<span class="kt-menu-arrow">
						<i class="ki-filled ki-right text-xs rtl:translate rtl:rotate-180">
						</i>
					</span>
				</div>
				<div class="kt-menu-default kt-menu-dropdown gap-0.5 w-[220px]">
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="https://devs.keenthemes.com">
							<span class="kt-menu-title">
								All Questions
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="https://devs.keenthemes.com/popular">
							<span class="kt-menu-title">
								Popular Questions
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="https://devs.keenthemes.com/question/create">
							<span class="kt-menu-title">
								Ask Question
							</span>
						</a>
					</div>
				</div>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="https://keenthemes.com/metronic/tailwind/docs/getting-started/license">
					<span class="kt-menu-title">
						Licenses &amp; FAQ
					</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="https://keenthemes.com/metronic/tailwind/docs">
					<span class="kt-menu-title">
						Documentation
					</span>
				</a>
			</div>
			<div class="kt-menu-separator">
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="https://keenthemes.com/contact">
					<span class="kt-menu-title">
						Contact Us
					</span>
				</a>
			</div>
		</div>
	</div>
</div>
<!-- End of Sidebar Menu -->